export default __webpack_public_path__ + "static/media/27e5fe306f4edbcd320428df80f9a6a401e1d77e8a49cf9092d0efe711757cfd.981cb80c.png";